import { useEffect, useState } from "react";
import { _Countries } from "../../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import usePaginator from "../../../../../../../modules/theme/Component/usePaginator";
import { toast } from "react-toastify";
import { Modal } from "../../../../../../../modules/theme/Component/Modal";
import { SelectCountry } from "./SelectCountry";
import { BasicButton } from "../../../../../../../modules/theme/Component/BasicButton";
import { BasicTable } from "../../../../../../../modules/theme/Component/BasicTable";
import { SelectDepartamentbyCountryID } from "./SelectDepartamentbyCountryID";



interface Props {
    label?: string;
    onChange: Function;
    idSelector: number;
    idCountry?: number
}

interface Search {
    Cities: string;
    Departament: string;
    Country: number;
}

export const DepartamentCitiesEditor = ({ onChange, label, idSelector, idCountry }: Props) => {

    const { lista, setLista, instance, bean, setBean } = useDataBean(_Countries);
    const paginador = usePaginator();
    const [valor, setValor] = useState<string>("");
    const [response, setResponse] = useState<Search>({
        Cities: "",
        Departament: "",
        Country: null
    })
    const [modal, setModal] = useState<any>({ name: 'Ciudades y Departamentos', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    useEffect(() => {
        if (idSelector) {
            instance.getCitiesByID(idSelector).then(
                (resp) => {
                    // console.log(resp)
                    // onChange(resp)
                    setValor(`${resp.Name}`)
                }
            ).catch(
                err => { toast.error(err) }
            )
        }
    }, [idSelector])

    useEffect(() => {
        if (idCountry) {
            setResponse({ ...response, Country: idCountry })
        }
    }, [idCountry])

    useEffect(() => {
        getLista();
    }, [paginador.page, response.Country])

    const returnData = () => {
        if (!bean.IDCities) {
            toast.error("Ciudad/Departamento no valido")
        } else {
            setValor(`${bean.Ciudad} - ${bean.Departamento}`)
            if (onChange) {
                onChange(bean);
            }
            setModal({ ...modal, view: false });
        }
    }

    const getLista = () => {
        const props = {
            Ciudad: response.Cities,
            Departamento: response.Departament,
            IDCountries: response.Country
        }
        instance.gerStatesCitiesRender(paginador.page, 15, props).then(
            (resp: any) => {
                setLista(resp.List)
                paginador.setPages(resp.NumberOfPages);
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }

    const head = [
        { title: 'ID', property: 'IDCities', visible: true },
        { title: 'Departamento', property: 'Departamento', visible: true },
        { title: 'Ciudad', property: 'Ciudad', visible: true },
    ]


    return (
        <>
            {label == " " ? null : (
                <label>{label ?? "Ciudad - Departamento"}</label>
            )}
            <div className="form-control text-wrap" style={{ minHeight: '35px' }} onClick={() => setModal({ ...modal, "view": true })}>
                {valor ? (
                    valor
                ) : (
                    <span>Seleccionar...</span>
                )}
            </div>

            <Modal onSubmitLabel='Seleccionar' modal={modal} updateModal={setModal} eventModal={() => { returnData() }}>
                <div className="row">
                    <div className="col-md-4">
                        <SelectCountry label="País" idSelector={response.Country ? response.Country : idCountry} onChange={(e) => { setResponse({ ...response, Country: e.IDCountries }) }} returnType="Object" />
                    </div>
                    <div className="col-md-4">
                        <SelectDepartamentbyCountryID idSelector={null} onChange={(e) => { setResponse({ ...response, Departament: e.Name }) }} countryID={response.Country} label="Departamento" returnType="Object" />
                    </div>
                    <div className="col-md-4">
                        <label >Cidudad</label>
                        <input type="text" className="form-control" value={response.Cities} onChange={(e) => { setResponse({ ...response, Cities: e.target.value }) }} />
                    </div>
                    <div className="col-md-2 mt-4">
                        <BasicButton eventClick={getLista} icon="ri-search-line" children={`Buscar`} />
                    </div>
                    <div className="col-md-12">
                        <BasicTable
                            body={lista}
                            head={head}
                            rowSet={setBean}
                            pageTop={paginador.page}
                            next={paginador.next}
                            back={paginador.back}
                            records={paginador}
                        />
                    </div>
                </div>
            </Modal>
        </>
    )
}